import { Flex, Text, chakra } from '@chakra-ui/react';
import type { OnboardingFormReturn } from '../useOnboardingForm';

const MAX_LEN = 500;

export function AboutStep({ form }: { form: OnboardingFormReturn }) {
  const { about, setAbout } = form;
  return (
    <Flex direction="column" gap="3">
      <Text fontSize="md" color="volyx.textSecondary">
        Tell organizations about yourself: what motivates you, past experience, anything you want them to know.
      </Text>
      <chakra.textarea
        value={about}
        onChange={(e) => setAbout(e.target.value.slice(0, MAX_LEN))}
        placeholder="Share a short introduction..."
        rows={6}
        resize="vertical"
        w="full"
        p="3"
        borderRadius="lg"
        border="1px solid"
        borderColor="volyx.borderLight"
        bg="white"
        color="volyx.text"
        fontFamily="body"
        fontSize="md"
        _focus={{ borderColor: 'volyx.action', outline: 'none', boxShadow: '0 0 0 3px rgba(0,122,255,0.18)' }}
      />
      <Text fontSize="xs" color="volyx.textSecondary" alignSelf="flex-end">
        {about.length}/{MAX_LEN}
      </Text>
    </Flex>
  );
}
